"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _TemplateTypes = _interopRequireDefault(require("./TemplateTypes"));

var _constants = require("./constants");

var TEMPLATES_URI = 'designmanager/v1/templates';
var LIMIT = 500;

var fetchTemplatesOfType = function fetchTemplatesOfType(types, queryOpts) {
  return _apiClient.default.get(TEMPLATES_URI, {
    query: (0, _extends2.default)({
      templateType__in: types,
      limit: LIMIT,
      property: [_constants.ID, _constants.LABEL, _constants.PATH, _constants.EXTENSION_NAME, _constants.GENERATED_FROM_LAYOUT_ID, _constants.TEMPLATE_TYPE, _constants.IS_FROM_LAYOUT, _constants.FOLDER],
      isAvailableForNewContent: true
    }, queryOpts)
  });
};

var fetchSubscriptionTemplates = function fetchSubscriptionTemplates() {
  return fetchTemplatesOfType([_TemplateTypes.default.SUBSCRIPTION_PREFERENCES, _TemplateTypes.default.UNSUBSCRIBE_CONFIRMATION, _TemplateTypes.default.UNSUBSCRIBE_SIMPLE], {
    includeDefaultTemplates: true
  });
};

var fetchSystemTemplates = function fetchSystemTemplates() {
  return fetchTemplatesOfType([_TemplateTypes.default.ERROR_PAGE, _TemplateTypes.default.PASSWORD_PAGE, _TemplateTypes.default.SEARCH_RESULTS]);
};

var fetchBlogTemplates = function fetchBlogTemplates() {
  return fetchTemplatesOfType([_TemplateTypes.default.BLOG_LISTING, _TemplateTypes.default.BLOG_POST], {
    includeDefaultTemplates: true
  });
};

var fetchStylesheets = function fetchStylesheets() {
  return _apiClient.default.get(TEMPLATES_URI, {
    query: {
      limit: LIMIT,
      includeDefaultTemplates: true,
      templateType: [_TemplateTypes.default.STYLESHEET]
    }
  });
};

var fetchMembershipTemplates = function fetchMembershipTemplates() {
  return _apiClient.default.get(TEMPLATES_URI, {
    query: {
      limit: 5000,
      includeDefaultTemplates: true,
      templateType__in: [_TemplateTypes.default.LANDING_PAGE, _TemplateTypes.default.MEMBERSHIP_LOGIN, _TemplateTypes.default.MEMBERSHIP_REGISTER, _TemplateTypes.default.MEMBERSHIP_RESET, _TemplateTypes.default.MEMBERSHIP_RESET_REQUEST, _TemplateTypes.default.MEMBERSHIP_EMAIL]
    }
  });
};

var DesignTemplatesAPI =
/*#__PURE__*/
function () {
  function DesignTemplatesAPI() {
    (0, _classCallCheck2.default)(this, DesignTemplatesAPI);
  }

  (0, _createClass2.default)(DesignTemplatesAPI, null, [{
    key: "getSubscriptionTemplates",
    value: function getSubscriptionTemplates() {
      return fetchSubscriptionTemplates();
    }
  }, {
    key: "getSystemTemplates",
    value: function getSystemTemplates() {
      return fetchSystemTemplates();
    }
  }, {
    key: "getBlogTemplates",
    value: function getBlogTemplates() {
      return fetchBlogTemplates();
    }
  }, {
    key: "getStylesheets",
    value: function getStylesheets() {
      return fetchStylesheets();
    }
  }, {
    key: "getMembershipTemplates",
    value: function getMembershipTemplates() {
      return fetchMembershipTemplates();
    }
  }]);
  return DesignTemplatesAPI;
}();

exports.default = DesignTemplatesAPI;
module.exports = exports.default;